import { useIsAuthenticated } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { AyudantiaInvestigacionData } from "../../interfaces/AYUDANTIAS/Ayudantia";
import { useAppSelector } from "../../redux/hooks";
import AyudantiaService from "../../services/AyudantiaService";
import { PantallaCargaPage } from "../../pages/Modulos/PantallaCargaPage";
import { Box, Container, Paper, Typography } from "@mui/material";
import { TableSolicitudAyudDirectivo } from "./TableSolicitudAyudDirectivo";


const ayudantiaService = new AyudantiaService();
export const SolicitudesAyudantiasDirectivo: React.FC<{}> = () => {

    const [solictudesDirectivo, setSolicitudesDirectivo] = useState<Array<AyudantiaInvestigacionData>>([]);
    const isAuthenticated = useIsAuthenticated();
    const token = useAppSelector((state) => state.authReducer.token);
    const { userData } = useAppSelector((state) => state.authReducer);
    const[ready, setReady] = useState<boolean>(false);

    // useEffect(()=>{
    //     let tipoPersonaDirectivo = userData.rolesInvestigacion.find(x=>x.idrol == 160) ? 'S':''; //VERIFICA TIPO DE PERSONA SEGUN EL ROL
    //     if (isAuthenticated ) { // Asegurar que idProy está definido
    //         //GetSolicitudesDirectivo(tipoPersonaDirectivo);
    //     }
    
    //   },[token,isAuthenticated])

   

    return(
        ready ?
        <Container maxWidth="lg" sx={{ padding: "20px" }}>
            <Typography
                variant="h4"
                align="center"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }}
            >
                SOLICITUDES DE AYUDANTÍAS
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
                <Box
                sx={{
                    height: 4,
                    width: "100px",
                    bgcolor: "primary.main",
                    borderRadius: "2px",
                }}
                />
            </Box>

            {
                ready ?
                <Container>
                    <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
                        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
                        Solicitudes pendientes
                        </Typography>
                        {/* <SolicitudesAyudTable showImpedimento={true} showRechazarTodo={true}
                        solicitudes={ solictudesDelegado.filter(x=> x.estadoPaso=="P")    }
                        /> */}
                        <TableSolicitudAyudDirectivo solicitudes={solictudesDirectivo.filter(x=>x.estadoPaso == 'P')} />
                    </Paper>

                    <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
                        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
                        Solicitudes aprobadas
                        </Typography>
                        {/* <SolicitudesAyudTable showImpedimento={false} showRechazarTodo={false}
                        solicitudes={ solictudesDelegado.filter(x=> x.estadoPaso=="A") }
                        /> */}
                    </Paper>

                    <Paper  elevation={3} sx={{ padding: 2, marginBottom: 3 }}>
                        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#243165", marginBottom: "20px", fontSize: "16px" }} gutterBottom>
                        Solicitudes Rechazadas
                        </Typography>
                        {/* <SolicitudesAyudTable showImpedimento={false} showRechazarTodo={false} 
                        solicitudes={ solictudesDelegado.filter(x=> x.estadoPaso=="N") }
                        /> */}
                    </Paper>

                </Container>
                :
                <PantallaCargaPage />
            }

        </Container>
        :
        <PantallaCargaPage />
    )

}